<script>
import { authComputed, authMethods } from '@state/helpers'

// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    // VuePerfectScrollbar,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isMenuOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    keluar() {
      this.logOut()
    },
    gantiPassword() {
      this.showModalPassword({ modalPassword: true })
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
      <!-- LOGO -->
      <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
        <span class="logo-lg">
          <img src="@assets/images/logo-ampro.png" alt height="48" />
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo-ampro.png" alt height="48" />
        </span>
      </a>

      <ul
        class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
      >
        <li class>
          <button
            class="button-menu-mobile open-left disable-btn"
            :class="{ open: isMenuOpened }"
            @click="toggleMenu"
          >
            <feather type="menu" class="menu-icon align-middle"></feather>
            <feather type="x" class="close-icon"></feather>
          </button>
        </li>
      </ul>
      <b-nav-item-dropdown
        right
        class="notification-list align-self-center profile-dropdown"
        toggle-class="nav-user mr-0"
      >
        <template v-slot:button-content>
          <div class="media user-profile">
            <img
              src="@assets/images/users/avatar-7.jpg"
              alt="user-image"
              class="rounded-circle align-self-center"
            />
            <div class="media-body text-left">
              <h6 class="pro-user-name ml-2 my-0">
                <span>{{ user.nama_lengkap }}</span>
                <span class="pro-user-desc text-muted d-block mt-1">{{
                  user.role
                }}</span>
              </h6>
            </div>
            <feather
              type="chevron-down"
              class="ml-2 align-self-center"
            ></feather>
          </div>
        </template>

        <b-dropdown-item @click="gantiPassword" class="notify-item p-0">
          <feather type="user" class="icon-dual icon-xs mr-2"></feather>
          <span>Ganti Password</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>

        <b-dropdown-item @click="keluar" class="notify-item p-0">
          <feather type="log-out" class="icon-dual icon-xs mr-2"></feather>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
